<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Reserved 4473's</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="closeComponent()"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <div
      class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
    >
      <div class="left-actions">
        <button
          class="btn modern-btn blue-btn btn-sm"
          (click)="getReserved4473sRecords()"
        >
          <i class="fa-solid fa-rotate me-2"></i>Refresh Table
        </button>
      </div>
      <div class="right-actions d-flex gap-2"></div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <ag-grid-angular
      id="dispo_list"
      class="modern-grid flex-grow-1"
      style="width: 100%; height: 100%"
      
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="sharedService.reserved_4473_list"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [components]="components"
      [enableBrowserTooltips]="true"
      [pagination]="true"
      [paginationPageSize]="sharedService.default_pagination_page_size"
    ></ag-grid-angular>
  </div>
</div>
